import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

//Bootstrap
import { Form } from "react-bootstrap";

//UI components
import FormFieldCurrency from "../../../ui/FormFieldCurrency";
import ErrorMessage from "../../../ui/ErrorMessage";

//Validation schema
import formEditRealiziranaVrednostSchema from "../../../../config/formEditRealiziranaVrednost";

//API calls
import { useEditRealiziraneVrednostiProjekta } from "../../../../services/ProjectDetails/financeAPI";

const RealiziranaVrednostProjektaEditForm = ({
  setIsEditing,
  realiziraneVrednosti,
}) => {
  const { id } = useParams();
  const schema = useMemo(() => formEditRealiziranaVrednostSchema, []);

  //PUT edit realizirane vrednosti projekta
  const {
    mutate: editRealiziraneVrednosti,
    isPending: isPendingEdit,
    isError,
    error,
    reset: resetMutationError,
  } = useEditRealiziraneVrednostiProjekta(id);

  const {
    handleSubmit,
    formState: { errors, isDirty },
    control,
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      realiziranaVrednost: realiziraneVrednosti?.realiziranaVrednost,
      realiziraniProjektniViri: realiziraneVrednosti?.realiziraniProjektniViri,
    },
  });

  const onSubmit = (data) => {
    const payload = {
      realiziranaVrednost: data?.realiziranaVrednost,
      realiziraniProjektniViri: data?.realiziraniProjektniViri,
    };

    editRealiziraneVrednosti(payload, {
      onSuccess: () => {
        setIsEditing(false);
      },
      onError: () => setTimeout(() => resetMutationError(), 3000),
    });
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <FormFieldCurrency
        label="Vrednost projekta"
        name="realiziranaVrednost"
        control={control}
        validationError={errors.realiziranaVrednost?.message}
      />
      <FormFieldCurrency
        label="Sofinanciranje iz projektnega vira"
        name="realiziraniProjektniViri"
        control={control}
        validationError={errors.realiziraniProjektniViri?.message}
      />
      <button
        type="submit"
        className="btn btn-primary mt-3"
        disabled={!isDirty || isPendingEdit}
      >
        {isPendingEdit ? "Shranjevanje..." : "Shrani"}
      </button>
      <button
        type="button"
        className="btn btn-secondary mt-3 ms-2"
        onClick={() => setIsEditing(false)}
      >
        Prekliči
      </button>
      {isError && <ErrorMessage message={error.message} />}
    </Form>
  );
};

export default RealiziranaVrednostProjektaEditForm;
